'use strict';

exports.__esModule = true;

var _createConnectedLink = require('./createConnectedLink');

var _createConnectedLink2 = _interopRequireDefault(_createConnectedLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = (0, _createConnectedLink2.default)();
Link.displayName = 'Link';

exports.default = Link;
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/found/lib/Link.js